<template>
  <div class="ds-tree" v-loading="isUpdate">
    <tree
      :bordered="bordered"
      :cicled="cicled"
      :data="treeData"
      :module="module"
      :edit-mode="editMode"
      :show-tools="showTools"
      :node-click-handler="nodeClickHandler"
    />
  </div>
</template>

<script>
import tree from "@/components/tree/tree";

export default {
  components: { tree },
  props: {
    bordered: Boolean,
    cicled: Boolean,
    "node-click-handler": Function,
    "edit-mode": Boolean,
    "show-tools": Boolean,
    module: String
  },
  data() {
    return {
      treeData: []
    };
  },
  computed: {
    isUpdate() {
      return this.$store.state.dsManager.update;
    }
  },
  methods: {
    sortData(data) {
      const sortedData = data.sort((a, b) => {
        if (a.datatype !== "model" && b.datatype === "model") return 1;
        if (a.datatype === "model" && b.datatype !== "model") return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;

        return 0;
      });

      return sortedData;
    },
    async updateDsTree() {
      this.$store.commit("SET_UPDATE_DS_TREE", true);
      const datasource = await this.$store.dispatch("POST_REQUEST", {
        url: `user/datasources`
      });

      this.treeData = this.sortData(datasource.data);
      this.$store.commit("SET_DATASOURCE", this.treeData);
      this.$store.commit("SET_UPDATE_DS_TREE", false);
    }
  },
  async mounted() {
    if (!this.isUpdate && this.$store.state.dsTreeState.dsTree.length) {
      this.treeData = this.$store.state.dsTreeState.dsTree;
    } else {
      this.updateDsTree();
    }
    this.$store.commit("SET_DATASOURCE", this.treeData);
  }
};
</script>

<style lang="scss">
.ds-tree {
  position: relative;
  height: 100%;
  overflow: hidden;
}
</style>
